import request from './request'

export function listMaterialRequirement(data) {
  return request.post('/production/material-requirements/list', data)
}
export function getMaterialRequirement(id) {
  return request.get('/production/material-requirements/' + id)
}
export function getMaterialRequirementByOrder(orderId) {
  return request.get('/production/material-requirements/by-order/' + orderId)
}
export function generateMaterialRequirement(orderIds) {
  return request.post('/production/material-requirements/generate', { orderIds })
}
export function confirmMaterialRequirement(requirementId) {
  return request.post('/production/material-requirements/confirm', { requirementId })
}
export function unconfirmMaterialRequirement(requirementId) {
  return request.post('/production/material-requirements/unconfirm', { requirementId })
}
export function setMaterialRequirementUseSubstitute(lineId, useSubstitute) {
  return request.post('/production/material-requirements/set-use-substitute', { lineId, useSubstitute })
}
export function deleteMaterialRequirement(ids) {
  return request.post('/production/material-requirements/delete', ids)
}
